import { Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { useApplication } from '../../../../context/ApplicationContext';
import { DisplayDateTime } from '../../../../utils/formats';
import { enumT } from '../../../../utils/helper';

// import Schemas
import Schema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const VerwendungsnachweisRichtSidebar: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<RightSidebarPaper>
				<span>
					<Typography>Online-Formular:</Typography>
					<Typography fontWeight={500} variant='body1'>
						Mittelabruf und Verwendungsnachweis
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Status:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Verwendungsnachweisstatus_Status.path))}
					</Typography>
				</span>
				<span>
					<Typography>Projektjahr:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Allgemein_Haushaltsjahr.path)}
					</Typography>
				</span>
				<span>
					<Typography>Förderprogramm:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path))}
					</Typography>
				</span>
				<span>
					<Typography>Projekttitel:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Referenz-Nummer:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Foerderantrag.schema.attributes.Allgemein_Referenz_Nr.path, 'ausstehend')}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Erstellt am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Zuletzt geändert am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, P.Allgemein_Geaendert_Durch_Antragsteller.path, ''))}
					</Typography>
				</span>
			</RightSidebarPaper>
		</>
	);
};
export default VerwendungsnachweisRichtSidebar;
